import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';
import {Translate} from 'views/module';

const ClientEditName = (props) => {
  const {
    oldData,
    newData,
  } = props;

  const oldClientName = oldData.clientName;
  const newClientName = newData.clientName;

  return (
    <Stack>
      <Translate
        expression='client.ClientDetail.Correspondance.Logs.EditName.Text'
        substitute={{
          oldClientName,
          newClientName,
        }}
      />
    </Stack>
  );
};
ClientEditName.propTypes = {
  oldData: PropTypes.object.isRequired,
  newData: PropTypes.object.isRequired,
};

export default React.memo(ClientEditName);
